import pubPizzaImg from "@assets/images/scan-to/ads/pub_pizza.jpg";
import pubGastronomieImg from "@assets/images/scan-to/ads/pub_gastronomie.jpg";
import pubGrilladesImg from "@assets/images/scan-to/ads/pub_grillades.jpg";

import { AdItem } from "./types";

export { LANGUAGE_CODES, SECTION_ICONS } from "../shared/constants";
export type { SectionIconEntry } from "../shared/constants";

// ─── Default section titles (multilingual) ─────────────
export const DEFAULT_SECTION_TITLES: Record<string, string> = {
    fr: "Publicité",
    en: "Advertising",
    ru: "Реклама",
    it: "Pubblicità",
    es: "Publicidad",
    pt: "Publicidade",
    de: "Werbung",
    ar: "إعلانات",
};

// ─── Default advertising images (local assets) ─────────
export const DEFAULT_AD_IMAGES: Record<number, string> = {
    1: pubPizzaImg,
    2: pubGastronomieImg,
    3: pubGrilladesImg,
};

export const DEFAULT_ADS: AdItem[] = [
    {
        id: 1,
        order: 1,
        filename: "pub_pizza.jpg",
        imageUrl: pubPizzaImg,
        active: true,
    },
    {
        id: 2,
        order: 2,
        filename: "pub_gastronomie.jpg",
        imageUrl: pubGastronomieImg,
        active: true,
    },
    {
        id: 3,
        order: 3,
        filename: "pub_grillades.jpg",
        imageUrl: pubGrilladesImg,
        active: true,
    },
];
